import React from 'react';
import { RoundTable } from './wizardTypes';
import SearchableDropdown from './SearchableDropdown';

interface WizardStep1Props {
    billType: 'single' | 'all';
    setBillType: (type: 'single' | 'all') => void;
    selectedRoundTableId: number | null;
    setSelectedRoundTableId: (id: number) => void;
    roundTables: RoundTable[];
    loadingRoundTables: boolean;
}

const WizardStep1: React.FC<WizardStep1Props> = ({
    billType,
    setBillType,
    selectedRoundTableId,
    setSelectedRoundTableId,
    roundTables,
    loadingRoundTables,
}) => {
    return (
        <div className="wizard-step">
            <h3>Allgemeine Informationen</h3>
            
            <div className="form-group">
                <label>Rechnungstyp <span className="required">*</span></label>
                <div className="radio-group">
                    <label className="radio-label">
                        <input
                            type="radio"
                            value="all"
                            checked={billType === 'all'}
                            onChange={(e) => setBillType(e.target.value as 'single' | 'all')}
                        />
                        <span>Rechnung für alle Round Tables</span>
                    </label>
                    <label className="radio-label">
                        <input
                            type="radio"
                            value="single"
                            checked={billType === 'single'}
                            onChange={(e) => setBillType(e.target.value as 'single' | 'all')}
                        />
                        <span>Rechnung für einen einzelnen Round Table</span>
                    </label>
                </div>
            </div>

            {billType === 'single' && (
                <SearchableDropdown
                    label="Round Table"
                    required={true}
                    options={roundTables.map(rt => ({
                        id: rt.id,
                        label: `${rt.number} - ${rt.name}`
                    }))}
                    value={selectedRoundTableId}
                    onChange={setSelectedRoundTableId}
                    placeholder="Round Table auswählen..."
                    disabled={loadingRoundTables}
                />
            )}
        </div>
    );
};

export default WizardStep1;
